<template>
  <transition
    enter-active-class="transform ease-out duration-300 transition"
    enter-from-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
    enter-to-class="translate-y-0 opacity-100 sm:translate-x-0"
    leave-active-class="transition ease-in duration-100"
    leave-from-class="opacity-100"
    leave-to-class="opacity-0"
  >
    <div
      v-if="show"
      class="fixed top-5 right-5 z-[100] max-w-sm w-full bg-premium-card border border-premium-border rounded-2xl shadow-2xl overflow-hidden pointer-events-auto"
    >
      <div class="p-4">
        <div class="flex items-start">
          <div class="flex-shrink-0">
            <template v-if="type === 'error'">
              <AlertCircle class="h-6 w-6 text-rose-500" />
            </template>
            <template v-else-if="type === 'success'">
              <CheckCircle class="h-6 w-6 text-emerald-500" />
            </template>
            <template v-else>
              <Info class="h-6 w-6 text-brand-500" />
            </template>
          </div>
          <div class="ml-3 w-0 flex-1 pt-0.5">
            <p class="text-sm font-bold text-white">
              {{ message }}
            </p>
          </div>
          <div class="ml-4 flex-shrink-0 flex">
            <button
              @click="close"
              class="rounded-lg inline-flex text-premium-dim hover:text-white focus:outline-none transition-colors"
            >
              <X class="h-5 w-5" />
            </button>
          </div>
        </div>
      </div>
      <!-- Progress Bar -->
      <div class="h-1 bg-premium-border overflow-hidden">
        <div 
          class="h-full bg-brand-500 transition-all duration-100 ease-linear"
          :style="{ width: progress + '%' }"
        ></div>
      </div>
    </div>
  </transition>
</template>

<script>
import { X, AlertCircle, CheckCircle, Info } from "lucide-vue-next";

export default {
  name: "AppToast",
  components: { X, AlertCircle, CheckCircle, Info },
  props: {
    message: { type: String, required: true },
    type: { type: String, default: "info" },
    duration: { type: Number, default: 4000 }
  },
  data() {
    return {
      show: true,
      progress: 100,
      timer: null,
      progressInterval: null
    };
  },
  methods: {
    close() {
      this.show = false;
      this.$emit("close");
    }
  },
  mounted() {
    const startTime = Date.now();
    this.progressInterval = setInterval(() => {
      const elapsed = Date.now() - startTime;
      this.progress = Math.max(0, 100 - (elapsed / this.duration) * 100);
      if (this.progress <= 0) {
        clearInterval(this.progressInterval);
      }
    }, 10);

    this.timer = setTimeout(() => {
      this.close();
    }, this.duration);
  },
  beforeUnmount() {
    clearTimeout(this.timer);
    clearInterval(this.progressInterval);
  }
};
</script>
